import { Reveal } from "@/components/Reveal";
import { Download, Globe } from "lucide-react";
import { api } from "@/lib/api";

const trackDownload = () => api.post("/track/brochure-download").catch(() => {});

export const ResearchBrochure = ({ webHref = "#cr-audiences" }) => (
  <section className="bg-navy py-24" data-testid="research-brochure-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-14 items-center">
      <Reveal className="lg:col-span-5">
        <p className="font-mono text-[11px] tracking-[0.35em] uppercase text-gold mb-4">
          Sponsor Brochure
        </p>
        <h2 className="font-serif text-2xl lg:text-4xl font-semibold text-ivory leading-tight mb-6">
          Take on cardiac studies without building a cardiac service.
        </h2>
        <p className="text-sm lg:text-base text-ivory/60 leading-relaxed mb-10 max-w-lg">
          Everything on this page as a printable document for your R&D office, sponsor
          or CRO — research echocardiography, core lab reading, visit-window scheduling,
          GCP and ALCOA+ compliance, and SoECAT-ready costing.
        </p>
        <div className="flex flex-wrap gap-4 mb-6">
          <a
            href="/CVI-UK-Research-Brochure.pdf"
            download="CVI-UK-Research-Brochure.pdf"
            data-testid="brochure-download-button"
            onClick={trackDownload}
            className="bg-gold text-navy font-mono text-xs tracking-[0.2em] uppercase px-8 py-4 hover:bg-champagne transition-colors inline-flex items-center gap-2.5"
          >
            <Download size={14} strokeWidth={1.75} /> Download PDF
          </a>
          <a
            href={webHref}
            data-testid="brochure-web-link"
            className="border border-ivory/30 text-ivory font-mono text-xs tracking-[0.2em] uppercase px-8 py-4 hover:border-gold hover:text-gold transition-colors inline-flex items-center gap-2.5"
          >
            <Globe size={14} strokeWidth={1.75} /> Read Web Version
          </a>
        </div>
        <p className="font-mono text-[10px] tracking-[0.25em] uppercase text-ivory/30">
          PDF · 4 pages · 450 KB
        </p>
      </Reveal>

      <Reveal className="lg:col-span-7" delay={0.15}>
        <div className="relative max-w-2xl mx-auto w-full">
          <div className="absolute -top-4 -right-4 w-full h-full border border-gold/50" />
          <object
            data="/CVI-UK-Research-Brochure.pdf#view=FitH&toolbar=0"
            type="application/pdf"
            className="relative w-full h-[420px] lg:h-[640px] bg-ivory"
            data-testid="brochure-pdf-viewer"
          >
            <a
              href="/CVI-UK-Research-Brochure.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="relative block w-full h-[420px] lg:h-[640px] group"
              data-testid="brochure-fallback-link"
            >
              <img
                src="/brochure-cover.png"
                alt="Cover of the CVI (UK) Research Sponsor Brochure"
                className="w-full h-full object-cover object-top"
              />
              <span className="absolute inset-x-0 bottom-0 bg-navy/90 backdrop-blur px-6 py-4 flex items-center justify-center gap-2 font-mono text-[11px] tracking-[0.25em] uppercase text-gold group-hover:bg-navy transition-colors">
                <Download size={13} strokeWidth={1.75} /> Open the Brochure
              </span>
            </a>
          </object>
          <p className="relative mt-3 text-center font-mono text-[10px] tracking-[0.2em] uppercase text-ivory/30">
            Preview not loading?{" "}
            <a
              href="/CVI-UK-Research-Brochure.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gold/70 hover:text-gold transition-colors"
              data-testid="brochure-open-link"
            >
              Open the PDF directly
            </a>
          </p>
        </div>
      </Reveal>
    </div>
  </section>
);
